import axios from './common/axios';

const API_URL_SHIPPINGS = '/shippings';
const API_URL_SHIPPINGS_CURRENT = '/shippings/current';

export default {
  getAll(callback) {
    axios
      .get(API_URL_SHIPPINGS)
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  getCurrent(params, callback) {
    axios
      .get(API_URL_SHIPPINGS_CURRENT, {
        params
      })
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  post(params, callback) {
    axios
      .post(API_URL_SHIPPINGS, params)
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  delete(params, callback) {
    // axios.delete を送信するときは { data: { foo: "bar" } } として送信する
    // https://github.com/axios/axios/issues/897#issuecomment-343715381
    axios
      .delete(API_URL_SHIPPINGS, {
        data: params
      })
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  postCurrent(params, callback) {
    axios
      .post(API_URL_SHIPPINGS_CURRENT, params)
      .then(function(res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  }
};
